<template>
  <div>
    <div
      class="estimate-loader"
      v-if="loading"
    >
      <span></span>
    </div>
    <div class="estimate-error" v-if="errorFlag && !loading">
      <p>正常にデータが取得できませんでした。<br>お手数ですが時間をあけて再度アクセスしていただくか、<br class="is-sp">お問い合わせください。
      </p>
    </div>
    <section
      class="estimate-option"
      v-if="!errorFlag && !loading"
    >
      <div class="estimate-option__header">
        <div class="estimate-option__header-inner">
          <h2 class="estimate-option__header-name">
            {{ bikeDetail.product_name }}
            <em
              v-for="note in selected.bike.notes"
              v-show="note.type == 'name'"
              v-html="`<sup>*${note.key}</sup>`"
              style="font-size: 0.8em;"
            />
            <br>
            <span>
              現金販売価格: {{ selected.bike.price_with_tax.toLocaleString() }}円
              <em
                v-for="note in selected.bike.notes"
                v-show="note.type == 'price'"
                v-html="`<sup>*${note.key}</sup>`"
              />
            </span>
            <span
              v-for="note in selected.bike.notes"
              v-show="note.type == 'price'"
              v-html="`<small>※${note.key} ${note.note}</small><br>`"
              class="note-attention"
            />
          </h2>
          <figure v-if="selected.bike.image != null">
            <img class="estimate-option__header-img" :src="selected.bike.image" :alt="bikeDetail.product_name" />
          </figure>
        </div>
      </div>
      <div class="estimate-option__options">
        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-text="options['color'].name" />
          <div class="estimate-option__item-list">
            <label
              v-for="(detail, index) in bikeDetail.details"
              :key="`color-${index}`"
              class="estimate-option__item-field"
            >
              <input type="radio" name="color" v-model="selectColor" :value="index">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label" v-text="detail.color" />
            </label>
          </div>
        </div>

        <div v-if="bikeDetail.product_type != '125' && bikeDetail.product_type != '50'" class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['pref'].name" />
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-select">
              <select
                name="pref"
                v-model="selected.pref"
              >
                <option
                  v-for="(pref, index) in bikeDetail.license_fee"
                  :key="`pref-${index}`"
                  :value="index"
                  v-text="pref.area_name"
                />
              </select>
            </label>
          </div>
          <p v-if="options['pref'].note != ''" class="estimate-option__item-note" v-text="options['pref'].note" />
        </div>

        <div class="estimate-option__item" v-if="bikeDetail.insurance.length > 0">
          <h4 class="estimate-option__item-title" v-html="options['insurance'].name" />
          <div class="estimate-option__item-list">
            <label
              class="estimate-option__item-field"
              v-for="(insurance, index) in bikeDetail.insurance"
              :key="`insurance-${index}`"
            >
              <input
                type="radio"
                v-model="selected.insurance"
                name="insurance"
                :value="index"
              >
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label"
                    v-text="`${insurance.month}ヶ月 ${insurance.price.toLocaleString()}円`" />
            </label>
          </div>
          <p v-if="options['insurance'].note != ''" class="estimate-option__item-note"
             v-text="options['insurance'].note" />
        </div>

        <div class="estimate-option__item" v-if="selected.bike.maintenance_pack.price > 0">
          <h4 class="estimate-option__item-title" v-html="options['maintenance'].name" />
          <p class="estimate-option__item-caption-link"><a href="/service/maintenance/" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-field">
              <input
                type="radio"
                name="maintenance"
                v-model="selected.maintenance"
                :value="1"
                checked
              >
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label"
                    v-text="`おすすめコース ${maintenanceName(selected.bike.maintenance_pack.course_name)}&nbsp; ${selected.bike.maintenance_pack.price.toLocaleString()}円`" />
            </label>
            <label class="estimate-option__item-field">
              <input
                type="radio"
                name="maintenance"
                v-model="selected.maintenance"
                :value="0"
              >
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">加入しない</span>
            </label>
          </div>
          <p v-if="options['maintenance'].note != ''" class="estimate-option__item-note"
             v-text="options['maintenance'].note" />
        </div>

        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['coating'].name" />
          <p class="estimate-option__item-caption-link"><a href="/aquly-coating/" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-field">
              <input
                type="checkbox"
                v-model="selected.coating"
                name="coating"
                :value="selected.bike.glass_coating.price"
              >
              <span class="estimate-option__item-checkbox"></span>
              <span class="estimate-option__item-label"
                    v-html="`基本施工<small>(ボディ・ホイールセット施工料)</small>&nbsp; <span>${selected.bike.glass_coating.price.toLocaleString()}円</span>`" />
            </label>
            <label
              v-for="(label, index) in selected.bike.glass_coating.options"
              class="estimate-option__item-field"
              :disabled="!selected.coating.includes(selected.bike.glass_coating.price)"
            >
              <input
                type="checkbox"
                name="coating"
                v-model="selected.coating_options"
                :value="label.price"
                :disabled="!selected.coating.includes(selected.bike.glass_coating.price)"
              >
              <span class="estimate-option__item-checkbox"></span>
              <span class="estimate-option__item-label"
                    v-text="`${label.option_name}&nbsp; ${label.price.toLocaleString()}円`" />
            </label>
          </div>
          <p v-if="options['coating'].note != ''" class="estimate-option__item-note" v-text="options['coating'].note" />
        </div>

        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['recorder'].name" />
          <p class="estimate-option__item-caption-link"><a href="https://honda-dream-japan.co.jp/wear-gear/#M820WD" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-field">
              <input type="radio" name="recorder" v-model="selected.recorder" :value="1">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">
                取り付ける　{{ (selected.bike.edr.price + selected.bike.edr.cost).toLocaleString()
                }}円{{ selected.bike.edr.cost > 0 ? `（工賃込）` : '（工賃別途 要相談）' }}
              </span>
            </label>
            <label class="estimate-option__item-field">
              <input type="radio" name="recorder" v-model="selected.recorder" :value="0">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">取り付けない</span>
            </label>
          </div>
          <p v-if="options['recorder'].note != ''" class="estimate-option__item-note"
             v-text="options['recorder'].note" />
        </div>

        <div class="estimate-option__item" v-if="selected.bike.etc && selected.bike.etc.price > 0">
          <h4 class="estimate-option__item-title" v-html="options['etc'].name" />
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-field">
              <input type="radio" name="etc" v-model="selected.etc" :value="1">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">
                取り付ける　{{ (selected.bike.etc.price + selected.bike.etc.cost).toLocaleString()
                }}円{{ selected.bike.etc.cost >= 0 ? `（工賃込）` : '（工賃要相談）' }}
              </span>
            </label>
            <label class="estimate-option__item-field">
              <input type="radio" name="etc" v-model="selected.etc" :value="0">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">取り付けない</span>
            </label>
          </div>
          <p v-if="options['etc'].note != ''" class="estimate-option__item-note" v-text="options['etc'].note" />
        </div>

        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['extendedWarranty'].name" />
          <p class="estimate-option__item-caption-link"><a href="/service/extended-warranty/" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label
              v-for="(item, index) in selected.bike.warranty"
              class="estimate-option__item-field"
            >
              <input
                type="radio"
                v-model="selected.extendedWarranty"
                name="extendedWarranty"
                :value="index">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">
                {{ item.year }}年延長　{{ item.price.toLocaleString() }}円
              </span>
            </label>
            <label class="estimate-option__item-field">
              <input
                type="radio"
                v-model="selected.extendedWarranty"
                name="extendedWarranty"
                :value="99"
                checked
              >
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">加入しない</span>
            </label>
          </div>
          <p v-if="options['extendedWarranty'].note != ''" class="estimate-option__item-note"
             v-text="options['extendedWarranty'].note" />
        </div>

        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['loan'].name" />
          <p class="estimate-option__item-caption-link"><a href="/service/credit/" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label
              v-for="(item, index) in selected.bike.loan"
              class="estimate-option__item-field"
            >
              <input
                type="radio"
                v-model="selected.loan"
                name="loan"
                :value="index">
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">
                {{ item.count }}回払い/{{ item.count / 12 }}年　(据置率{{ item.residual_ratio }}％)
              </span>
            </label>
            <label class="estimate-option__item-field">
              <input
                type="radio"
                v-model="selected.loan"
                name="loan"
                :value="99"
                checked
              >
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label">一括払い</span>
            </label>
          </div>
          <p v-if="options['loan'].note != ''" class="estimate-option__item-note" v-text="options['loan'].note" />
        </div>

        <div class="estimate-option__item">
          <h4 class="estimate-option__item-title" v-html="options['expenses'].name" />
          <p class="estimate-option__item-caption-link"><a :href="expensesPdf" target="_blank">詳しくはこちらをご覧ください</a></p>
          <div class="estimate-option__item-list">
            <label class="estimate-option__item-field">
              <input type="radio" v-model="selected.expenses" name="expenses" value="1" checked>
              <span class="estimate-option__item-radio"></span>
              <span class="estimate-option__item-label" v-text="`${expensesPrice.toLocaleString()}円`" />
            </label>
          </div>
          <p class="estimate-option__item-note">
            諸費用は下記の内容が含まれます。<br>
            ・手続代行費用<br>
            <span v-html="weightTax ? '・重量税<br>' : ''" />
            ・G防犯登録<br>
            <span v-html="etcNote ? '・ETCセットアップ手数料<br>' : ''" />
            <span v-html="bikeDetail.product_type != '125' && bikeDetail.product_type != '50' ? '・ナンバー代<br>' : ''" />
            <span v-html="bikeDetail.product_type != '125' && bikeDetail.product_type != '50' ? '・印紙代' : ''" />
          </p>
        </div>
      </div>

      <estimate-note
        class="estimate-result__note"
        :extended-notes="extendedNotes"
      />

      <footer class="estimate-option__footer is-stuck">
        <div class="estimate-option__footer-grid">
          <figure class="estimate-option__footer-img">
            <img :src="selected.bike.image" :alt="bikeDetail.product_name">
          </figure>
          <div class="estimate-option__footer-details">
            <h5 class="estimate-option__footer-name" v-text="bikeDetail.product_name" />
            <p class="estimate-option__footer-color" v-text="selected.bike.color" />
            <p class="estimate-option__footer-price">
              <small>総支払金額</small>
              <span v-text="totalPrice.toLocaleString()" />
              <small>円</small>
            </p>
          </div>
          <p class="estimate-option__footer-submit">
            <button class="button" @click="onClickSubmit">
              <span>見積もり結果を表示</span>
            </button>
          </p>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'
import axios from 'axios'
import { Util } from './master.js'
import EstimateNote from './estimate/EstimateNote.vue'

export default defineComponent({
  name: 'EstimateOption',
  components: {
    EstimateNote
  },
  props: {},
  setup(props) {
    const urlParams = new URLSearchParams(window.location.search)
    const
      loading = ref(true),
      productID = ref(urlParams.get('id')),
      bikeDetail = ref({}),
      totalPrice = ref(0),
      selectColor = ref(0),
      selected = ref({
        bike: {},
        color: 0,
        pref: 0,
        insurance: 0,
        maintenance: 0,
        coating: [],
        coating_options: [],
        recorder: 0,
        etc: 0,
        extendedWarranty: 99,
        loan: 99,
        expenses: 1
      }),
      expensesPrice = ref(0),
      expensesPdf = ref(""),
      weightTax = ref(false),
      etcNote = ref(false),
      errorFlag = ref(false),
      extendedNotes = ref([])

    // 総支払金額の計算
    const setTotalPrice = () => {
      let price = 0

      if (Object.keys(bikeDetail.value).length === 0) {
        return 0
      }

      let newSelected = { ...selected.value }

      if (newSelected.coating.length == 0 && newSelected.coating_options.length > 0) {
        newSelected.coating_options = []
      }

      const {
        bike,
        pref,
        insurance,
        maintenance,
        coating,
        coating_options,
        recorder,
        etc,
        extendedWarranty,
        loan
      } = newSelected

      weightTax.value = (bikeDetail.value.product_type !== '50' && bikeDetail.value.product_type !== '125')

      if (bike.maintenance_pack.price > 0) {
        price += maintenance === 1 ? bike.maintenance_pack.price : 0
      } else if (newSelected.maintenance != 0 ) {
        newSelected.maintenance = 0
      }

      price += coating.length > 0 ? bike.glass_coating.price : 0
      price += coating_options.reduce((sum, coatingPrice) => sum + coatingPrice, 0)
      price += recorder === 1 ? bike.edr.price + bike.edr.cost : 0
      price += etc === 1 ? bike.etc.price + bike.etc.cost : 0
      price += extendedWarranty !== 99 ? bike.warranty[extendedWarranty].price : 0
      price += loan !== 99 ? bike.loan[loan].summary : bike.price_with_tax

      // 諸費用計算
      let newExpensesPrice = 0

      newExpensesPrice += bikeDetail.value.license_fee[pref].price
      newExpensesPrice += bikeDetail.value.overhead

      if (bike.etc.price > 0) {
        newExpensesPrice += etc === 1 ? bikeDetail.value.etc_fee : 0
        etcNote.value = etc === 1
      } else if (bikeDetail.value.etc_fee > 0) {
        // 標準装備
        newExpensesPrice += bikeDetail.value.etc_fee
        etcNote.value = true
      }
      price += newExpensesPrice

      // 自賠責保険
      price += bikeDetail.value.insurance[insurance].price

      expensesPrice.value = newExpensesPrice
      totalPrice.value = price
      selected.value = newSelected
    }

    // ウォッチャーの初期化
    const initializeWatchers = () => {
      // カラー選択時の処理
      watch(selectColor, (newVal) => {
        selected.value.color = newVal
        selected.value.bike = bikeDetail.value.details[newVal]

        extendedNotes.value = []
        selected.value.bike.notes.forEach((note) => {
          extendedNotes.value.push(`<sup>*${note.key}</sup> ${note.note}`)
        })
        setTotalPrice()
      })

      // 個々のプロパティを監視
      watch(() => selected.value.pref, setTotalPrice)
      watch(() => selected.value.insurance, setTotalPrice)
      watch(() => selected.value.maintenance, setTotalPrice)
      watch(() => selected.value.coating, setTotalPrice)
      watch(() => selected.value.coating_options, setTotalPrice)
      watch(() => selected.value.recorder, setTotalPrice)
      watch(() => selected.value.etc, setTotalPrice)
      watch(() => selected.value.extendedWarranty, setTotalPrice)
      watch(() => selected.value.loan, setTotalPrice)
    }

    // メンテナンスパック名
    const maintenanceName = (type) => {
      return type === '5S' ? '(5回の点検 + 車検)' : type === '6T' ? '(6回の点検)' : ''
    }

    return {
      errorFlag,
      productID,
      loading,
      bikeDetail,
      totalPrice,
      selectColor,
      selected,
      etcNote,
      maintenanceName,
      onClickSubmit: async () => {
        // localstrage に selected を保存
        await localStorage.setItem(`estimateResult-${productID.value}`, JSON.stringify({
          product_id: urlParams.get('id'),
          product_name: bikeDetail.value.product_name,
          product_type: bikeDetail.value.product_type,
          result: selected.value,
          insurance: bikeDetail.value.insurance,
          license_fee: bikeDetail.value.license_fee,
          etc_fee: bikeDetail.value.etc_fee,
          overhead: bikeDetail.value.overhead
        }))
        // 見積もり結果ページへ遷移
        location.href = `../result/?id=${urlParams.get('id')}`
      },
      options: Util.ESTIMATE.OPTIONS,
      expensesPrice,
      expensesPdf,
      weightTax,
      setTotalPrice,
      initializeWatchers,
      extendedNotes
    }
  },
  async mounted() {
    let result = await this.getDetailData(this.productID)

    this.setExpensesPdf()

    const estimateHistory = localStorage.getItem(`estimateResult-${this.productID}`)
    if (estimateHistory) {
      const historyData = JSON.parse(estimateHistory)

      if (historyData.product_id === this.productID) {
        this.selected = historyData.result
        this.selectColor = this.selected.color
      }
    }

    this.setTotalPrice()
    this.initializeWatchers()

    this.loading = false

    if (!result) {
      this.errorFlag = true
    }
  },
  methods: {
    async getDetailData(id) {
      try {
        const response = await axios.get(`${Util.API.estimateDetails}/${id}.json`)
        this.bikeDetail = response.data
        this.selected.bike = this.bikeDetail.details[0]
        this.selected.insurance = 0
        this.selected.pref = 0
        this.selected.recorder = 0
        this.selected.etc = 0
        this.selected.maintenance = 1

        this.selected.bike.notes.forEach((note) => {
          this.extendedNotes.push(`<sup>*${note.key}</sup> ${note.note}`)
        })

        return true
      } catch (error) {
        this.errorFlag = true
        console.error('エラーが発生しました:', error)
        return false
      }
    },
    setExpensesPdf() {
      const shopData = Util.DEALER.area
      const shopID = localStorage.getItem('shopID')
      let filterData = []

      shopData.forEach((area) => {
        // area.shops 内のアイテムで shop_id が shopIDと一致するものを取得
        const result = area.shops.filter((shop) => shop.shop_id == shopID)
        if (result.length > 0) {
          filterData.push(result[0])
        }
      })

      const pdfName = filterData.length > 0 ? filterData[0].expenses_pdf : 'universal_certified-factory.pdf'

      this.expensesPdf = `/wp-content/themes/HDJ2024_v1/assets/img/service/other-service/${pdfName}`
    }
  }
})
</script>
